import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { Acl } from 'modules/common/components/Acl';
import moment from 'moment';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import { numberWithCommas, convertToTitleCase } from '../../../../helper';
// import { IconSearch } from 'modules/common/components/Icons';
import * as actions from '../actions';
import * as c from '../constant';
import ViewUploadModal from '../modals/ViewUploadModal';
import AddRecordModal from '../modals/AddRecordModal';

const RPTBilling = ({
  getList,
  list,
  isLoading,
  pager,
  getUploadedList,
  uploadList,
  pagerUpload,
  isLoadingUpload,
  deleteFileHistoryUpload,
  deleteFileUpload,
  permissions,
}) => {
  const [formData, setFormData] = useState({
    overwrite_previous: 0,
    is_active: 1,
  });
  const setModal = useContext(ModalContext);

  const [viewUploadHistory, setViewUploadHistory] = useState(false);

  const token = get('token') || '';

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const handleChangePage = (page) => {
    getList({ ...formData, page });
  };

  const handleChangePageUpload = (page) => {
    getUploadedList({ ...formData, page });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    getList({ is_active: 1 });
  }, []);

  // const onUpload = (e) => {
  //   e.preventDefault();

  //   const data = new FormData();
  //   data.append('file', e.target.files[0]);
  //   data.append(
  //     'overwrite_previous',
  //     _.get(formData, 'overwrite_previous') ? 1 : 0
  //   );
  //   upload(data, () => {
  //     getList({ is_active: 1 });
  //   });
  // };

  const onSearch = (e) => {
    e.preventDefault();
    getList(formData);
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      tdn: '',
      pin: '',
      year: '',
      is_active: 1,
    });
    getList({
      overwrite_previous: 0,
      is_active: 1,
    });
  };

  const formatPeriod = (data) => {
    return data
      ? data
          .replace('-1', ' - 1st quarter')
          .replace('-2', ' - 2nd quarter')
          .replace('-3', ' - 3rd quarter')
          .replace('-4', ' - 4th quarter')
      : '---';
  };

  const postFormData = (url) => (formdata, onProgress) =>
    new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;
        // eslint-disable-next-line no-unused-vars
        xhr.addEventListener('timeout', (e) =>
          resolve({
            status: 400,
            message: 'Request Timeout, Please try again.',
          })
        );
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.onload = () => {
          try {
            const jsonResponse = JSON.parse(xhr.response);
            const response = {
              status: xhr.status, // jsonResponse.status,
              data: jsonResponse,
            };
            resolve(response);
          } catch (err) {
            reject(err);
          }
        };
        xhr.onerror = () => {
          const errRes = {
            data: false,
            message: 'Oops..Something went wrong.',
          };
          Alert.error(errRes);
          return resolve(errRes);
        };
        if (xhr.upload) {
          xhr.upload.onprogress = (evt) => {
            if (evt.lengthComputable) {
              const progress = Math.ceil((evt.loaded / evt.total) * 100);
              if (onProgress) {
                onProgress(progress);
              }
            }
          };
        }
        xhr.send(formdata);
      } catch (err) {
        reject(err);
      }
    });
  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();
    try {
      data.append('file', file);
      data.append(
        'overwrite_previous',
        _.get(formData, 'overwrite_previous') ? 1 : 0
      );
      data.append('is_delinquent', _.get(formData, 'is_delinquent') ? 1 : 0);
      const res = await postFormData(
        `${process.env.REACT_APP_WS}api/v1/administrators/rpt_billing_csv_imports/upload_csv`
      )(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        setViewUploadHistory(true);
        getUploadedList({ subject: 'RPTAX' });
        // getList({ is_active: 1 });
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.message'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  const handleOnViewFailedUploads = (e) => {
    e.preventDefault();
    setViewUploadHistory(true);
    getUploadedList({ subject: 'RPTAX' });
  };

  const handleOnAllTransactions = (e) => {
    e.preventDefault();
    setViewUploadHistory(false);
    getList({ is_active: 1 });
  };

  const handleViewFailedRows = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      title: 'View Failed Uploaded Files',
      isOpen: true,
      content: <ViewUploadModal dataInfo={dataInfo} />,
      modalSize: 'modal-xxl',
    });
  };

  const handleDeleteButtonClicked = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete ${
        _.get(data, 'attributes.bin') || 'this item'
      }?`,
      () => {
        deleteFileUpload(data.id, () => {
          getList({ is_active: 1 });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleDeleteFileClicked = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete ${
        _.get(data, 'attributes.file_name') || 'this item'
      }?`,
      () => {
        deleteFileHistoryUpload(data.id, () => {
          getUploadedList({ subject: 'RPTAX' });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AddRecordModal type="ADD" />,
      title: 'Add Record',
      modalSize: 'modal-lg',
    });
  };

  const handleUpdateFileClicked = (detail) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddRecordModal
          type="EDIT"
          dataInfo={detail.attributes}
          id={detail.id}
        />
      ),
      title: 'Edit Record',
      modalSize: 'modal-lg',
    });
  };

  // const handleEdit = data => e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <UpdateModal updateList={data.attributes} id={data.id} />,
  //     title: 'Update Announcement',
  //     modalSize: 'modal-md',
  //   });
  // };

  // const handleRemove = data => e => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to remove?',
  //     () => {
  //       removeUserManagement(data.id, () => {
  //         getUserManagementList({}, response => {
  //           const id = _.get(response, 'data.0.id');
  //           history.push(`/important-notification/${id}`);
  //           showUserManagement(id);
  //         });
  //       });
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  const paymentStatusBadge = status => {

    if (status === 'PENDING') return (<span className='bg-warning px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    if (status === 'PAID') return (<span className='bg-success px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    if (status.includes('QUARTER')) return (<span className='bg-success px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    
    return '---'
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-2 my-3 pl-2">
        <h2 className="mt-1 header-title font-weight-bold text-dark">
          Real Property Tax Billing
        </h2>
        <div className="d-flex">
          <div className="row-nav-end">
            {Acl(permissions, ['ADD RECORD RPTAX']) && (
              <button
                type="button"
                onClick={handleAddModal}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
              >
                <i className="fa fa-plus py-2 mr-2" /> Add Record
              </button>
            )}
            {!viewUploadHistory && (
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleOnViewFailedUploads}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary h-100"
                >
                  Upload History
                </button>
              </div>
            )}
            {viewUploadHistory && (
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleOnAllTransactions}
                  className="btn btn-link button-upload cms-bg-color-primary cms-outline-primary h-100"
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="p-4 billing-container">
        {!viewUploadHistory && (
          <form
            className="form-billing-container px-4 pt-4 d-flex justify-content-between"
            onSubmit={onSearch}
          >
            <div className="form-search-container d-flex flex-row">
              <div className="d-flex flex-column mr-2">
                <label className="label-title mb-2">TDN</label>
                <input
                  className="form-control-billing text-dark"
                  name="tdn"
                  onChange={onChange}
                  value={_.get(formData, 'tdn')}
                />
              </div>
              <div className="d-flex flex-column">
                <label className="label-title mb-2">PIN</label>
                <input
                  className="form-control-billing text-dark"
                  name="pin"
                  onChange={onChange}
                  value={_.get(formData, 'pin')}
                />
              </div>
              <div className="search-div d-flex align-items-start ml-2 pt-4">
                <button
                  type="submit"
                  className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                >
                  <div className="form-control-icon d-flex">
                    <span className="icon">
                      <i className="fa fa-lg fa-search" />
                    </span>
                    <span className="title-icon">Search</span>
                  </div>
                </button>
                <button
                  onClick={onClear}
                  type="button"
                  className="btn btn-link button-clear cms-bg-color-primary cms-outline-primary ml-2"
                >
                  <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                </button>
              </div>
            </div>

            <div className="form-upload-container flex-column">
              <div className="d-flex pl-4">
                <div className="div-upload">
                  <label className="text-color-title mb-0">Upload Items</label>
                </div>
                <div className="d-flex flex-row flex-fill justify-content-end">
                  <div className="mr-2">
                    <input
                      name="overwrite_previous"
                      type="checkbox"
                      className="check-box"
                      checked={_.get(formData, 'overwrite_previous')}
                      onChange={onChange}
                    />
                  </div>
                  <label className="overwrite-label mb-0">Overwrite</label>
                </div>
                <div className="d-flex flex-row flex-fill justify-content-end">
                  <div className="mr-2">
                    <input
                      name="is_delinquent"
                      type="checkbox"
                      className="check-box"
                      checked={_.get(formData, 'is_delinquent')}
                      onChange={onChange}
                    />
                  </div>
                  <label className="overwrite-label mb-0">Delinquent</label>
                </div>
              </div>

              <div className="form-group mt-1 d-flex justify-content-end">
                {isLoading && (
                  <i className="fa fa-spin fa-spinner my-auto mr-2" />
                )}
                <input
                  type="file"
                  className="btn btn-link input-upload"
                  onChange={fileHandler}
                />
                {/* {!isLoading && (
                  <input
                    type="file"
                    className="btn btn-link input-upload w-100"
                    onChange={fileHandler}
                  />
                )} */}
                <button
                  type="button"
                  onClick={onUploadFile}
                  className="ml-2 btn btn-link button-upload cms-bg-color-primary cms-outline-primary"
                >
                  Upload
                </button>
              </div>
              <p className="override-p">
                Note: Overriding makes the upload replace the current active
                items.{' '}
              </p>
            </div>
          </form>
        )}
        {viewUploadHistory ? (
          <div className="card">
            <div className="card-body">
              <div className="table-billing-container">
                {isLoadingUpload ? (
                  <div
                    className="loading d-flex text-center justify-content-center align-items-center"
                    style={{ height: '500px' }}
                  >
                    <div className="spinner text-center ">
                      <span className="fas fa-5x fa-spin fa-spinner" />
                    </div>
                  </div>
                ) : (
                  <div className="table-scroll">
                    <table className="table table-sm table-hover" style={{ minWidth: '1700px' }}>
                      <thead className="table-header">
                        <tr className="billing-table-tr">
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            File Name
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Date Imported
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Failed Rows
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Total Rows
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Status
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {uploadList.map((item) => {
                          return (
                            <tr
                              className="billing-table-tr"
                              key={_.get(item, 'id')}
                            >
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.file_name') || '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.date_imported')
                                  ? moment(
                                      `${_.get(
                                        item,
                                        'attributes.date_imported'
                                      )}`
                                    ).format('MMM DD, YYYY')
                                  : '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.failed_rows') || '0'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.total_rows')}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.status')}
                              </td>
                              <td
                                className="p-3 align-middle"
                                style={{ width: '124px' }}
                              >
                                {_.get(item, 'attributes.failed_rows') > 0 ? (
                                  <>
                                    {Acl(permissions, [
                                      'RPT BILLINGS ALLOW DELETE',
                                    ]) && (
                                      <button
                                        type="button"
                                        className="btn-blank"
                                        onClick={handleDeleteFileClicked(item)}
                                      >
                                        <i className="far fa-trash-alt icon-delete" />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      onClick={handleViewFailedRows(item)}
                                      className="btn-blank"
                                    >
                                      <i className="far fa-eye icon-view cms-bg-color-secondary" />
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    {Acl(permissions, [
                                      'RPT BILLINGS ALLOW DELETE',
                                    ]) && (
                                      <button
                                        type="button"
                                        className="btn-blank"
                                        onClick={handleDeleteFileClicked(item)}
                                      >
                                        <i className="far fa-trash-alt icon-delete" />
                                      </button>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="list-pagination">
                  {pagerUpload.total_pages > 1 ? (
                    <div className="d-flex justify-content-center text-center align-item-center">
                      <Pagination
                        data={pagerUpload}
                        onChange={handleChangePageUpload}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* upload */}
            <div className="card">
              <div className="card-body">
                <div className="table-billing-container">
                  {isLoading ? (
                    <div
                      className="loading d-flex text-center justify-content-center align-items-center"
                      style={{ height: '500px' }}
                    >
                      <div className="spinner text-center ">
                        <span className="fas fa-5x fa-spin fa-spinner" />
                      </div>
                    </div>
                  ) : (
                    <div className="table-scroll">
                      <table className="table table-sm table-hover" style={{ minWidth: '1700px' }}>
                        <thead className="table-header">
                          <tr>
                            <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                              TDN
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              PIN
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Account Name
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Amount
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Status
                            </th>
                            {Acl(permissions, [
                              'RPT BILLINGS ALLOW DELETE',
                            ]) && (
                              <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                                Action
                              </th>
                            )}  
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              From
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              To
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Date Processed
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Expiration Date
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Delinquent
                            </th>
                          </tr>
                        </thead>
                        <tbody className="table-details">
                          {list.map((item) => {
                            return (
                              <tr
                                className="billing-table-tr"
                                key={_.get(item, 'id')}
                              >
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.tdn') || '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.pin') || '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.account_name') ||
                                    '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  <b>PHP</b>&nbsp;
                                  {numberWithCommas(
                                    _.get(item, 'attributes.amount')
                                  ) || '0.00'}
                                </td>
                                <td className="py-3 align-middle">
                                  {paymentStatusBadge(_.get(item, 'attributes.payment_status'))}
                                </td>
                                <td
                                  className="p-3 align-middle"
                                  style={{ width: '124px' }}
                                >
                                  {Acl(permissions, [
                                    'UPDATE RECORD RPTAX',
                                  ]) && (
                                    <button
                                      type="button"
                                      className="btn-blank"
                                      onClick={handleUpdateFileClicked(item)}
                                    >
                                      <i className="far fa-edit icon-edit cms-bg-color-primary" />
                                    </button>
                                  )}
                                  {Acl(permissions, [
                                    'RPT BILLINGS ALLOW DELETE',
                                  ]) && (
                                    <button
                                      type="button"
                                      className="btn-blank"
                                      onClick={handleDeleteButtonClicked(item)}
                                    >
                                      <i className="far fa-trash-alt icon-delete" />
                                    </button>
                                  )}
                                </td>
                                <td className="py-3 align-middle">
                                  {formatPeriod(
                                    _.get(item, 'attributes.mode_of_payment_1')
                                  )}
                                </td>
                                <td className="py-3 align-middle">
                                  {formatPeriod(
                                    _.get(item, 'attributes.mode_of_payment_2')
                                  )}
                                </td>
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.date_processed')
                                    ? moment(
                                        `${_.get(
                                          item,
                                          'attributes.date_processed'
                                        )}`
                                      ).format('MMM DD, YYYY')
                                    : '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.expiration_date')
                                    ? moment(
                                        `${_.get(
                                          item,
                                          'attributes.expiration_date'
                                        )}`
                                      ).format('MMM DD, YYYY')
                                    : '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  {+_.get(item, 'attributes.is_delinquent')
                                    ? 'YES'
                                    : 'NO'}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="list-pagination">
                    {pager.total_pages > 1 ? (
                      <div className="d-flex justify-content-center text-center align-item-center">
                        <Pagination data={pager} onChange={handleChangePage} />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

RPTBilling.propTypes = {
  getUploadedList: PropTypes.instanceOf(Function).isRequired,
  uploadList: PropTypes.instanceOf(Array).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingUpload: PropTypes.bool.isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  pagerUpload: PropTypes.instanceOf(Object).isRequired,
  deleteFileUpload: PropTypes.instanceOf(Function).isRequired,
  deleteFileHistoryUpload: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  list: _.get(api, `${c.LIST}.list`) || [],
  uploadList: _.get(api, `${c.UPLOAD_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
  isLoadingUpload: _.get(api, 'loading', []).indexOf(c.UPLOAD_LIST) > -1,
  pagerUpload: _.get(api, `${c.UPLOAD_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RPTBilling);
